import {SyntheticEvent} from 'react'
import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {
  isAnyPremium,
  isNotPremium,
  hasAllPremiumComponents,
} from '@freckle/educator-entities/ts/common/logic/premium-access'
import {PremiumLicensesAttrs} from '@freckle/educator-entities/ts/common/models/premium-licenses'
import {Image} from '@freckle/educator-materials/ts/components/img'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {TeacherSupportButton} from '@freckle/educator-materials/ts/components/support-button/teacher'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {logout} from '@freckle/classroom/ts/common/helpers/logout'
import {getSupportLink} from '@freckle/classroom/ts/common/helpers/support'
import {TeacherAttrs} from '@freckle/classroom/ts/users/models/teacher'
import {EarnRewards} from './earn-rewards'
import {GetPremium} from './get-premium'
import {Resources} from './resources'
import {UserOptions} from './user-options'
import {rightNav, navbarLogoLink, navbarLogoImg} from './navbar.module.scss'

function onClickLogoutBtn(e: SyntheticEvent<EventTarget, Event>) {
  e.preventDefault()
  logout()
}

type Props = {
  teacher: TeacherAttrs
  premiumLicenses: PremiumLicensesAttrs
}

export function NavbarComponent(props: Props) {
  const {teacher, premiumLicenses} = props

  const {t} = useSafeTranslation()

  const premiumStatus = isAnyPremium(premiumLicenses) ? 'paid' : 'free'

  return (
    <div className="mainTeacherTopNavBar">
      <nav className={`main-navbar hidden-print`}>
        <Link href="/" reactRouter className={navbarLogoLink}>
          <Image
            src={`${PATHS.imageAssetsUrl}/company-logos/renaissance-freckle-logo.svg`}
            alt={t('NAVBAR_LOGO_ALT_TITLE_FRECKLE')}
            title={t('NAVBAR_LOGO_ALT_TITLE_FRECKLE')}
            className={navbarLogoImg}
          />
        </Link>

        <div className={rightNav}>
          {!hasAllPremiumComponents(premiumLicenses) && <EarnRewards />}
          {isNotPremium(premiumLicenses) && <GetPremium />}

          <Resources {...teacher} />

          <TeacherSupportButton
            supportLink={getSupportLink(premiumStatus, teacher.countryCode)}
            countryCode={teacher.countryCode}
          />

          <UserOptions
            teacher={teacher}
            onLogout={onClickLogoutBtn}
            premiumLicenses={premiumLicenses}
          />
        </div>
      </nav>
    </div>
  )
}
